import { Link } from "gatsby"
import React from "react"
import altBg from "../images/tetleys-bg-alt-bw-sm.png"
import newsArticleOne from "../images/news/digital-periodic-maintenance-sm.jpg"
import newsArticleOneWebp from "../images/news/digital-periodic-maintenance-sm.webp"
import imgTetleysInvestYutongs from '../images/news/tetleys-invest-yutongs-sm.jpg'
import imgTetleysAcquired from '../images/news/tetleys-coaches-acquired-by-first-sm.jpg'

const NewsStrip = () => (
  <div className="block-news" style={{ background: `url(${altBg}) no-repeat top center fixed`, backgroundSize: 'cover' }}>
    <div className="body gutter">
      <h3 data-aos='fade-left' data-aos-duration="300">Latest news from Tetley's</h3>
      <div className="block-news__articles">
        <div className="block-news__article" data-aos='fade-up' data-aos-delay="100" data-aos-duration="300">
          <Link className="block-news__article-link" to="/news/tetleys-coaches-acquired-by-first/" style={{height: "100%"}}>
            <picture>
              <img src={imgTetleysAcquired} alt="" />
            </picture>
            <div className="block-news__article__content">
              <p>Tetley's acquired by FirstGroup</p>
            </div>
          </Link>
        </div>
        <div className="block-news__article" data-aos='fade-up' data-aos-delay="100" data-aos-duration="300">
          <Link className="block-news__article-link" to="/news/tetleys-coaches-invests-in-two-new-yutong-gt12-coaches/" style={{height: "100%"}}>
            <picture>
              <img src={imgTetleysInvestYutongs} alt="" />
            </picture>
            <div className="block-news__article__content">
              <p>Tetley's invest in two new Yutong GT12 coaches</p>
            </div>
          </Link>
        </div>
        <div className="block-news__article" data-aos='fade-up' data-aos-delay="100" data-aos-duration="300">
          <Link className="block-news__article-link" to="/news/commitment-to-safety/" style={{height: "100%"}}>
            <picture>
              <source type="image/webp" srcSet={newsArticleOneWebp} />
              <img src={newsArticleOne} alt="" />
            </picture>
            <div className="block-news__article__content">
              <p>Commitment to safety</p>
            </div>
          </Link>
        </div>

      </div>
    </div>
  </div>
)

export default NewsStrip